import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import LandownerDetailScreen from './screens/LandownerDetailScreen';
import LandownerListScreen from './screens/LandownerListScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';

ManageLandowner.propTypes = {};

function ManageLandowner(props) {
  const { isLandlordInfo } = props;
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0 pb-4">
        <Routes>
          <Route path="" element={<LandownerListScreen />} />
          <Route
            path={"/add"}
            element={<EditAgencyScreen agencyRole="LANDLORD" />}
          />
          <Route path="/:landownerId" element={<LandownerDetailScreen isLandlordInfo={isLandlordInfo} />} />
          <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
          <Route
            path={"/:agencyId/edit"}
            element={<EditAgencyScreen agencyRole="LANDLORD" isEditUserAgency={true} />}
          />
          <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageLandowner;
